var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.722 13.9895H8.14097C7.61492 13.9895 7.18848 14.4058 7.18848 14.9194V15.8536C7.18848 16.3672 7.61492 16.7835 8.14097 16.7835H17.722C18.248 16.7835 18.6744 16.3672 18.6744 15.8536V14.9194C18.6744 14.4058 18.248 13.9895 17.722 13.9895Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 11.1958H17.722C18.2478 11.1958 18.6744 11.6124 18.6744 12.1257V13.0599C18.6744 13.5732 18.2478 13.9898 17.722 13.9898H8.14097C7.61516 13.9898 7.18848 13.5732 7.18848 13.0599",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1487 8.40576H17.7216C18.2474 8.40576 18.6741 8.82234 18.6741 9.33569V10.2698C18.6741 10.7832 18.2474 11.1998 17.7216 11.1998H12.2566",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1924 5.61157H16.1534C16.6792 5.61157 17.1059 6.02815 17.1059 6.5415V7.47564C17.1059 7.98899 16.6792 8.40557 16.1534 8.40557H14.1924",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74945 12.2265C9.92479 12.2265 12.4989 9.71335 12.4989 6.61324C12.4989 3.51313 9.92479 1 6.74945 1C3.57412 1 1 3.51313 1 6.61324C1 9.71335 3.57412 12.2265 6.74945 12.2265Z",
    stroke: "#6856DB",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86995 9.43699H7.52056C8.29204 9.43699 8.91698 8.82685 8.91698 8.07365C8.91698 7.32045 8.29204 6.71031 7.52056 6.71031H5.9345C5.16303 6.71031 4.53809 6.10018 4.53809 5.34698C4.53809 4.59378 5.16303 3.98364 5.9345 3.98364H8.58511",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99048 3.12915V3.98334",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 9.52954V10.2491",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/Price.601f2d385dd6ae729fdbaa695556a24a.svg";
export { ForwardRef as ReactComponent };